module.exports = __webpack_public_path__ + "static/img/check-fff.23a1b63.jpg";